// extracted by mini-css-extract-plugin
export default {"container":"add-voucher_container__gaBhi"};